// extracted by mini-css-extract-plugin
export default {"OpenOrderListPage":"OpenOrderListPage_OpenOrderListPage__j2otR"};